// PageVariablesEmpresas.js

export const pageVariables = {
    headers: [
        'NOME', 'DESCRIÇÃO', 'VALOR','REGRA DE FATURAMENTO', 'EMPRESA'
    ],
    headerInfo: {
        title: "Planos",
        description: "Esta seção fornece informações detalhadas sobre os planos, incluindo dados como nome, descrição, valor, empresa associada e regras de faturamento. Acompanhe e gerencie os planos disponíveis para garantir que estejam adequados às necessidades empresariais e operacionais."
    },     
    inputs: [
        {
            name: "nome",
            type: "text",
            label: "Nome"
        },
        {
            name: "descricao",
            type: "text",
            label: "Descrição"
        },
        {
            name: "empresa_nome",
            type: "text",
            label: "Empresa",
            readonly: true
        },
        {
            name: "valor",
            type: "text",
            label: "Valor"
        },
        {
            name: "regra_de_faturamento",
            type: "text",
            label: "Regra de Faturamento"
        },
        {
            name: "tipo_plano",
            type: "select",
            label: "Tipo de Plano",
            options: ["Vida em Grupo", "Vida Individual"]
        },
        {
            name: "logo_seguradora",
            type: "text",
            label: "Logo da Seguradora"
        },
    ],
    page: process.env.VUE_APP_API_URL+"planos",
    planosFilterPage: process.env.VUE_APP_API_URL+"planos/filter"
};
